import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import axiosService from '../../../../../utils/AxiosService'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function AudienceCountryFilter() {
  const { search } = useContext(SearchContext)
  const [options, setOptions] = useState([])
  const [minPercentage, setMinPercentage] = useState(search.min_audience_country_percentage)
  const timeout = useRef(null)

  useEffect(() => {
    axiosService.get('/api/project_manager/authentications/audience_countries')
      .then(countries => setOptions(countries.map(country => ({ label: country.name, value: country.id }))))
    return () => clearTimeout(timeout.current)
  }, [])

  useEffect(() => {
    setMinPercentage(search.min_audience_country_percentage)
  }, [search.min_audience_country_percentage])

  const setCountries = countries => {
    search.audience_countries = countries.map(country => country.value)
    search.selectedAudienceCountries = countries
    search.order = countries.length ? 'audience_countries' : 'reach'
  }

  const changeMinPercentage = ({ target: { value } }) => {
    setMinPercentage(value)
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      search.min_audience_country_percentage = value
    }, 600)
  }

  const disabled = !search.audience_countries.length

  return (
    <div className="flex w-full items-center gap-2">
      <div className="min-w-0 flex-1">
        <ReactMultiSelect
          placeholder="Any country"
          name="filter"
          onChange={setCountries}
          options={options}
          value={search.selectedAudienceCountries}
          hasSelectAll={false}
        />
      </div>
      <label title={disabled ? 'Pick a country first' : 'Minimum share of the audience from the selected countries'} className={`flex h-11 w-24 shrink-0 items-center gap-1 rounded-lg border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode px-2 text-sm focus-within:border-2 focus-within:border-rb-green ${disabled ? 'rb-disabled' : ''}`}>
        <span className="text-rb-mat-grey dark:text-gray-400">≥</span>
        <input
          type="text"
          inputMode="numeric"
          value={minPercentage}
          onChange={changeMinPercentage}
          disabled={disabled}
          className="w-full border-0 bg-transparent p-0 text-right text-rb-black dark:text-white focus:ring-0"
        />
        <span className="text-rb-mat-grey dark:text-gray-400">%</span>
      </label>
    </div>
  )
})
